<!-- 移动端 header 菜单组件 -->
<template>
  <div>
    <div class="mobile-header f-b-c">
      <div class="mobile-header-left f--c">
        <i class="iconfont icon-menu-fill" @click="menuVisible = true"></i>
        <img class="mobile-logo" src="@/assets/img/mobile-logo.jpg">
      </div>
      <div class="mobile-header-right f-c-c">
        <span class="p-r" :style="{ paddingRight: `${String($store.state.common.shoppingCartSkuNum || '').length * .05}rem`}" @click="showShoppingCart">
          <i class="iconfont icon-shangpin-gouwudai"></i>
          <span v-show="$store.state.common.shoppingCartSkuNum > 0" class="mobile-cart-num">{{$store.state.common.shoppingCartSkuNum > 99 ? '99+' : $store.state.common.shoppingCartSkuNum}}</span>
        </span>
        <!-- <i class="iconfont icon-fenlei" @click="categoryDrawerVisible = true"></i> -->
      </div>
    </div>

    <!-- 菜单抽屉 -->
    <el-drawer el-drawer :visible.sync="menuVisible" direction="ltr" size="50%" class="mobile-menu-drawer" :show-close="true">
      <div class="mobile-menu-user f--c">
        <i class="iconfont icon-user-3-line"></i>
        <span>{{$store.state.common.userName}}</span>
      </div>
      <div class="back" @click="jumpProductList">
        {{ $t('Components.Mobile.Header.BackToShopping') }}
      </div>
      <Menu @select="menuVisible = false" />

      <!-- 登出按钮 -->
      <el-button class="mobile-logout" @click="logOut">{{$t('currency.logOut')}}</el-button>
    </el-drawer>
    <!-- 购物车抽屉 -->
    <ShoppingCart ref="shoppingCart" />
    <!-- 品类抽屉 -->
    <CategoryDrawer v-model="categoryDrawerVisible"></CategoryDrawer>
  </div>
</template>

<script>
import Menu from '@/components/layout/Menu'
import CategoryDrawer from '@/components/mobile/CategoryDrawer.vue'
import ShoppingCart from '@/components/ShoppingCart.vue'
// import bus from '@/util/bus.js'
export default {
  components: { Menu, CategoryDrawer, ShoppingCart },
  data() {
    return {
      menuVisible: false,
      categoryDrawerVisible: false,
      shoppingCartDrawerVisible: false
    }
  },
  methods: {
    logOut() {
      this.$parent.logOut()
    },
    showShoppingCart() {
      // bus.$emit('showCartDrawer')
      this.$refs.shoppingCart.show()
    },
    jumpProductList() {
      location.href = '/product-list'
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-header{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: 0.86rem;
  padding: 0 0.3rem;
  background: white;
  z-index: 1999;
  .icon-menu-fill{
    font-size: 0.46rem;
    margin-right: 0.22rem;
  }
  .mobile-logo{
    width: 2.07rem;
    height: 0.45rem;
  }
  .mobile-header-right{
    .mobile-cart-num{
      position: absolute;
      top: -0.12rem;
      left: 0.25rem;
      background: #AB1E1A;
      line-height: .2rem;
      text-align: center;
      border-radius: 10px;
      color: white;
      padding: .02rem .05rem;
      font-size: .24rem;
    }
    .icon-shangpin-gouwudai{
      font-size: 0.4rem;
    }
    .icon-fenlei{
      font-size: 0.48rem;
      margin-left: 0.2rem;
    }
  }
}

.mobile-menu-user{
  font-weight: 500;
  font-size: .24rem;
  padding: 0 0 0.2rem 0.4rem;
  i{
    margin-right: 0.06rem;
    color: #909399;
    font-size: .28rem;
  }
}

.mobile-logout{
  position: absolute;
  bottom: .5rem;
  left: 0;
  right: 0;
  width: 80%;
  margin: 0 10%;
  font-size: .28rem;
}
</style>
<style lang="scss">
.mobile-menu-drawer .el-drawer__body{
  overflow-x: hidden;
}
.mobile-menu-drawer .el-drawer__header{
  margin-bottom: 0.4rem;
}
.mobile-menu-drawer .back{
  padding: 0 20px;
  height: .8rem;
  line-height: .8rem;
  font-size: .28rem;
}
</style>
